/**
 * Parses a TestTemas launch path/href into the query fields the page expects.
 * Safe to call with relative paths (e.g. /usuario/test-temas?tema=...).
 */
export function parseTestTemasLaunchQuery(launchHref) {
  const empty = {
    pestana: "",
    bloque: "",
    tema: "",
    curso: "",
  };

  if (typeof launchHref !== "string" || !launchHref.trim()) {
    return empty;
  }

  try {
    const url = new URL(launchHref.trim(), "http://localhost");
    return {
      pestana: url.searchParams.get("pestana") || "",
      bloque: url.searchParams.get("bloque") || "",
      tema: url.searchParams.get("tema") || "",
      curso: (url.searchParams.get("curso") || "").trim(),
    };
  } catch {
    return empty;
  }
}
